export default "__VITE_ASSET__CTaQrpLo__"